import React, { Component } from 'react';
import KheshtiRug from './rugTemplates/kheshtiRug';
import AfshanRug from './rugTemplates/afshanRug';
import LachakToranjRug from './rugTemplates/lachakToranjRug';
import ModernRug from './rugTemplates/modernRug';

export default class SimilarRugsMobileSidebar extends Component {

    render() {
        let rugs = [];
        if (this.props.rugs) {
            this.props.rugs.map((rug, i) => {
                let key = rug.id
                // Rug type is different when its coming from the API
                let rugType = rug.id ? rug.rug_type : rug.type
                switch (rugType) {
                    case "lachak-toranj":
                        rugs.push(
                            <div className="check" key={key} onClick={() => { this.props.clickHandler(rug, i) }}>
                                <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                                <LachakToranjRug
                                    background={rug.background}
                                    border={rug.border}
                                    corner={rug.corner}
                                    toranj={rug.toranj}
                                    show={true}
                                />
                            </div>
                        )
                        break;
                    case "kheshti":
                        rugs.push(
                            <div className="check" key={key} onClick={() => { this.props.clickHandler(rug, i) }}>
                                <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                                <KheshtiRug
                                    background={rug.background}
                                    tile={rug.tile}
                                    show={true}
                                />
                            </div>
                        )
                        break;
                    case "modern":
                        rugs.push(
                            <div className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                                <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                                <ModernRug
                                    background={rug.background}
                                    tile={rug.tile}
                                    show={true}
                                />
                            </div>
                        )
                        break;
                    case "your_picture":
                        rugs.push(
                            <div className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                                <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                                <ModernRug
                                    background={rug.background}
                                    tile={rug.tile}
                                    show={true}
                                />
                            </div>
                        )
                        break;
                    default:
                        rugs.push(
                            <div className="check active" key={key} onClick={() => { this.props.clickHandler(rug, i) }}>
                                <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                                <AfshanRug
                                    background={rug.background}
                                    border={rug.border}
                                    show={true}
                                />
                            </div>
                        )
                        break;
                }
                return ""
            })
        }
        return (
            <div className="similar-mobile-display">
                <p className=""> {this.props.texts["similarRugs"]} </p>
                <div className="ul-body relative">
                    {rugs}
                </div>
            </div>
        )
    }
}